export default "__VITE_ASSET__DpXUXKR___"